import React, { createContext, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../src/contexts/StoreContext.jsx';

const LanguageContext = createContext(undefined);

export const LanguageProvider = observer(({ children }) => {
  const { settingsStore, localizationStore } = useStore();
  const language = settingsStore.language;
  const value = {
    language,
    dir: language === 'ar' ? 'rtl' : 'ltr',
    t: localizationStore.currentLocaleTranslations,
    setLanguage: (lang) => settingsStore.setLanguage(lang)
  };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
});

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
};

